// src/pages/admin/Building/CreateBuilding.jsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  FaArrowLeft,
  FaSave,
  FaTimes,
  FaSpinner,
  FaBuilding,
  FaMapMarkerAlt,
  FaMoneyBillWave,
  FaPhone,
  FaEnvelope,
  FaGlobe,
  FaUsers,
  FaBed,
  FaCheckCircle,
  FaStar,
} from 'react-icons/fa';
import { successToast, errorToast } from '../../Utils/toast';
import { useCreateBuildingMutation } from '../../redux/services/buildingService/building.Services';
import CommonBreadcrumb from '../../common/CommonBreadcrumb';
function CreateBuilding() {
  const navigate = useNavigate();
  const [createBuilding, { isLoading }] = useCreateBuildingMutation();

  const [formData, setFormData] = useState({
    name: '',
    type: 'samaj_bhawan',
    description: '',
    address: '',
    city: '',
    state: '',
    country: 'India',
    pincode: '',
    phone: '',
    email: '',
    website: '',
    capacity: '',
    rooms: '',
    facilities: '',
    price_per_day: '',
    security_deposit: '',
    is_featured: false,
    is_active: true,
    status: 'approved',
    meta_title: '',
    meta_description: '',
    meta_keywords: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      errorToast('Building name is required');
      return;
    }

    try {
      const response = await createBuilding(formData).unwrap();
      successToast(response?.message || 'Building created successfully');
      navigate('/admin/buildings');
    } catch (error) {
      console.error('Create error:', error);
      errorToast(error?.data?.message || 'Failed to create building');
    }
  };

  return (
    <div>
      {/* HEADER */}
      {/* <div className="page-header-breadcrumb all_breadcrumb">
        <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
          <nav>
            <h4 className="fw-semibold">
              <Link to="/admin/buildings" className="text-primary me-2">
                <FaArrowLeft />
              </Link>
              <FaBuilding className="me-2 text-warning" />
              Create Building
            </h4>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item active">
                <Link to="/admin">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/admin/buildings">Buildings</Link>
              </li>
              <li className="breadcrumb-item">Create Building</li>
            </ol>
          </nav>
        </div>
        <div className="page-title fw-semibold fs-18 mb-0">
          <button
            className="btn btn-secondary me-2"
            onClick={() => navigate('/admin/buildings')}
          >
            <FaTimes className="me-1" /> Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <FaSpinner className="spinning me-2" />
                Creating...
              </>
            ) : (
              <>
                <FaSave className="me-1" /> Create Building
              </>
            )}
          </button>
        </div>
      </div> */}
<CommonBreadcrumb
    title="Create Building"
    titleIcon={<FaBuilding className="me-2 text-warning" />}
    breadcrumbs={[
        { label: "Home", link: "/admin" },
        { label: "Buildings", link: "/admin/buildings" },
        { label: "Create Building" },
    ]}
    buttons={[
       {
            text: isLoading ? "Creating..." : "Create Building",
            icon: isLoading ? (
                <FaSpinner className="spinning me-2" />
            ) : (
                <FaSave className="me-1" />
            ),
            onClick: handleSubmit,
            disabled: isLoading,
            className: "btn btn-primary",
        },
        {
            text: "Cancel",
            icon: <FaTimes className="me-1" />,
            onClick: () => navigate("/admin/buildings"),
            className: "btn btn-danger",
        }
       
    ]}
/>
      {/* FORM */}
      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row">
              {/* Basic Information */}
              <div className="col-12">
                <h5 className="fw-bold mb-3">📋 Basic Information</h5>
              </div>

              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label>
                    Building Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter building name"
                    required
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group mb-3">
                  <label>
                    Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="type"
                    value={formData.type}
                    onChange={handleChange}
                    required
                  >
                    <option value="samaj_bhawan">Samaj Bhawan</option>
                    <option value="dharamshala">Dharamshala</option>
                    <option value="community_hall">Community Hall</option>
                    <option value="marriage_hall">Marriage Hall</option>
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group mb-3">
                  <label>Status</label>
                  <select
                    className="form-control"
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option value="pending">Pending</option>
                    <option value="approved">Approved</option>
                    <option value="rejected">Rejected</option>
                  </select>
                </div>
              </div>

              <div className="col-12">
                <div className="form-group mb-3">
                  <label>Description</label>
                  <textarea
                    className="form-control"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Enter building description"
                    rows="4"
                  />
                </div>
              </div>

              {/* Location Information */}
              <div className="col-12 mt-3">
                <h5 className="fw-bold mb-3">
                  <FaMapMarkerAlt className="me-2" /> Location Information
                </h5>
              </div>

              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label>Address</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="Enter address"
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group mb-3">
                  <label>City</label>
                  <input
                    type="text"
                    className="form-control"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    placeholder="Enter city"
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group mb-3">
                  <label>State</label>
                  <input
                    type="text"
                    className="form-control"
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    placeholder="Enter state"
                  />
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group mb-3">
                  <label>Country</label>
                  <input
                    type="text"
                    className="form-control"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    placeholder="Enter country"
                  />
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group mb-3">
                  <label>Pincode</label>
                  <input
                    type="text"
                    className="form-control"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                    placeholder="Enter pincode"
                  />
                </div>
              </div>

              {/* Contact Information */}
              <div className="col-12 mt-3">
                <h5 className="fw-bold mb-3">
                  <FaPhone className="me-2" /> Contact Information
                </h5>
              </div>

              <div className="col-md-4">
                <div className="form-group mb-3">
                  <label>Phone</label>
                  <input
                    type="tel"
                    className="form-control"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter phone number"
                  />
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group mb-3">
                  <label>Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter email address"
                  />
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group mb-3">
                  <label>Website</label>
                  <input
                    type="url"
                    className="form-control"
                    name="website"
                    value={formData.website}
                    onChange={handleChange}
                    placeholder="Enter website URL"
                  />
                </div>
              </div>

              {/* Building Details */}
              <div className="col-12 mt-3">
                <h5 className="fw-bold mb-3">
                  <FaBuilding className="me-2" /> Building Details
                </h5>
              </div>

              <div className="col-md-3">
                <div className="form-group mb-3">
                  <label>Capacity (People)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="capacity"
                    value={formData.capacity}
                    onChange={handleChange}
                    placeholder="Max capacity"
                    min="0"
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group mb-3">
                  <label>Rooms</label>
                  <input
                    type="number"
                    className="form-control"
                    name="rooms"
                    value={formData.rooms}
                    onChange={handleChange}
                    placeholder="Number of rooms"
                    min="0"
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label>Facilities</label>
                  <input
                    type="text"
                    className="form-control"
                    name="facilities"
                    value={formData.facilities}
                    onChange={handleChange}
                    placeholder="e.g., Parking, AC, WiFi, Kitchen"
                  />
                </div>
              </div>

              {/* Pricing */}
              <div className="col-12 mt-3">
                <h5 className="fw-bold mb-3">
                  <FaMoneyBillWave className="me-2" /> Pricing
                </h5>
              </div>

              <div className="col-md-4">
                <div className="form-group mb-3">
                  <label>Price Per Day (₹)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="price_per_day"
                    value={formData.price_per_day}
                    onChange={handleChange}
                    placeholder="Enter price per day"
                    min="0"
                    step="100"
                  />
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group mb-3">
                  <label>Security Deposit (₹)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="security_deposit"
                    value={formData.security_deposit}
                    onChange={handleChange}
                    placeholder="Enter security deposit"
                    min="0"
                    step="100"
                  />
                </div>
              </div>

              {/* Options */}
              <div className="col-12 mt-3">
                <h5 className="fw-bold mb-3">⚙️ Options</h5>
              </div>

              <div className="col-md-4">
                <div className="form-group mb-3">
                  <div className="form-check mt-2">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="is_featured"
                      checked={formData.is_featured}
                      onChange={handleChange}
                      id="is_featured"
                    />
                    <label className="form-check-label" htmlFor="is_featured">
                      <FaStar className="text-warning me-1" /> Featured Building
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group mb-3">
                  <div className="form-check mt-2">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="is_active"
                      checked={formData.is_active}
                      onChange={handleChange}
                      id="is_active"
                    />
                    <label className="form-check-label" htmlFor="is_active">
                      <FaCheckCircle className="text-success me-1" /> Active Building
                    </label>
                  </div>
                </div>
              </div>

              {/* Meta Information */}
              <div className="col-12 mt-3">
                <h5 className="fw-bold mb-3">🔍 SEO / Meta Information</h5>
              </div>

              <div className="col-12">
                <div className="form-group mb-3">
                  <label>Meta Title</label>
                  <input
                    type="text"
                    className="form-control"
                    name="meta_title"
                    value={formData.meta_title}
                    onChange={handleChange}
                    placeholder="Meta title for SEO"
                  />
                </div>
              </div>

              <div className="col-12">
                <div className="form-group mb-3">
                  <label>Meta Description</label>
                  <textarea
                    className="form-control"
                    name="meta_description"
                    value={formData.meta_description}
                    onChange={handleChange}
                    placeholder="Meta description for SEO"
                    rows="2"
                  />
                </div>
              </div>

              <div className="col-12">
                <div className="form-group mb-3">
                  <label>Meta Keywords</label>
                  <input
                    type="text"
                    className="form-control"
                    name="meta_keywords"
                    value={formData.meta_keywords}
                    onChange={handleChange}
                    placeholder="Comma separated keywords"
                  />
                </div>
              </div>

              {/* Submit Button */}
              <div className="col-12 mt-4">
                <button
                  type="submit"
                  className="btn btn-primary btn-lg w-100"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <FaSpinner className="spinning me-2" />
                      Creating Building...
                    </>
                  ) : (
                    <>
                      <FaSave className="me-2" />
                      Create Building
                    </>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateBuilding;